import { Btn, DisplayHeading, Eyebrow, Lede } from "./primitives";
import { SITE } from "@/content/siteConfig";
import { pushAuditStart } from "@/lib/analytics";
import type { ReactNode } from "react";


export function ContactCTA({ num = "Get in touch", homepage = false, children }: { num?: string; homepage?: boolean; children?: ReactNode }) {
  return (
    <section className="bhg-section contact-cta">
      <div className="wrap">
        <div className="grid items-end gap-12 md:grid-cols-[1.4fr_1fr]">
          <div>
            <Eyebrow>{num}</Eyebrow>
            <DisplayHeading as="h2">
              Start with an <span className="display-italic">audit.</span>
            </DisplayHeading>
            <div className="mt-6 max-w-xl">
              <Lede>
                We&apos;ll review your current Google and Meta accounts, pull spend and conversion
                data, and show you {homepage ? "where the leaks are before you commit to anything." : "where the leaks are, before you commit to anything."}
              </Lede>
            </div>
            <div className="mt-8 flex flex-wrap gap-2">
              <Btn to="/audit" onClick={() => pushAuditStart("inline")}>
                Get your free audit →
              </Btn>
              <Btn href={SITE.emailHref} variant="ghost">
                Email Jett
              </Btn>
            </div>

          </div>

          <ul
            className="m-0 list-none p-0"
          >
            {[
              ["Email", SITE.email],
              ["Phone", SITE.phoneDisplay],
              ["Location", SITE.locationDisplay],
              ["Languages", SITE.languages],
            ].map(([lbl, val]) => (
              <li
                key={lbl}
                className="grid items-baseline gap-6"
                style={{
                  gridTemplateColumns: "120px 1fr",
                  padding: "20px 0",
                  borderBottom: "1px solid rgba(0,47,167,0.12)",
                }}
              >
                <span
                  className="mono"
                  style={{
                    fontSize: 10.5,
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                    color: "rgba(0,47,167,0.45)",
                  }}
                >
                  {lbl}
                </span>
                <span style={{ fontSize: 15, color: "#002FA7" }}>{val}</span>
              </li>
            ))}
          </ul>
        </div>
        {children}
      </div>
    </section>
  );
}
